import NotPurchasedAddon from "./not_purchased_addon";
import AddonButton from "./addon_button";
import FreeButton from "./free_button";
import SubscribeButton from "./subscribe_button";
import RenewButton from "./renew_button";
import NotLoggedButton from "./not_logged_button";
import {CatalogContext} from "./catalog_context";

const CountryProductButton = (props) => {
    let catalogCtx = React.useContext(CatalogContext);
    const { catalog_data } = catalogCtx;
    let product = props.product;
    let button;
    let alreadyBought = false;
    let expirationDate = new Date(product.expiration_date_ts * 1000);
    let currentDate = new Date();
    if(product.key === 'ch.xample.airac.database.worldwide.aeronautical'){ //check add on if Aero DB
        if(product.status){
            alreadyBought = true; // if addon status property is ready
        }
    } else {
        if (product.status === 'ready') {
            alreadyBought = true; // if addon status property is ready
        }
    }
    // Check if user is logged in
    if(catalogModule.isAuthenticated()){
        // Check if user can purchase the product
        if(catalogModule.userCanPurchase()){
            if (!alreadyBought || product.type === "consumable") { // if user has not bought the addon
                if (product.hasOwnProperty("price") && product.price > 0) { // check product if exist
                    if (product.state === "hidden" || product.key.indexOf("consum.flightplan") >= 0) { // Check if product is not hidden or not a flightplan
                        button = <NotPurchasedAddon/>;
                    } else { //products that are not hidden and are already owned
                        button = <AddonButton {...props} />
                    }
                } else {
                    if (product.type === "free") {
                        button = <FreeButton {...props} />
                    } else {
                        if(product.type === "subscription"){
                            button = <button className="anp-button is-primary full-width" onClick={() => freeSubscription(product.key, this)} title={gettext("Click here to subscribe this free addon")}><span className="cart">{gettext("Subscribe")}</span></button>;
                        } else {
                            button = <SubscribeButton {...props} type={'paypal'} />
                        }
                    }
                }
            } else { // If user has bought an addon
                if(product.type === 'subscription'){
                    if (product.hasOwnProperty("expiration_date") && expirationDate < currentDate) {
                        // For multiple store view
                        button = <RenewButton {...props} isPurchased={false}/>
                    } else if (product.hasOwnProperty("expiration_date_ts") && expirationDate < currentDate) {
                        // For single product view
                        button = <RenewButton {...props} isPurchased={false}/>
                    } else {
                        button = <RenewButton {...props} isPurchased={true} />
                    }
                } else {
                    button = <RenewButton {...props} isPurchased={true} />
                }
            }
        }
    } else {
        button = <NotLoggedButton type={product.type}/>
    }
    return (
        <React.Fragment>
            {button}
        </React.Fragment>
    )
};

export default CountryProductButton
